import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";

export type TabPanelItem = {
  label: string;
  children: JSX.Element;
};

export type TabPanelProps = {
  name: string;
  items: TabPanelItem[];
  selectedTabIndex?: number;
  tabIndexChanged?: (tabIndex: number) => void;
} & React.ComponentProps<typeof Tabs>;

export const TabPanel = ({ name, items, selectedTabIndex, tabIndexChanged, ...rest }: TabPanelProps) => {
  const [tabIndex, setTabIndex] = useState(selectedTabIndex ?? 0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    if (tabIndexChanged) tabIndexChanged(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabIndex} onChange={handleChange} {...rest}>
          {items.map((item, index) => (
            <Tab label={item.label} key={index} />
          ))}
        </Tabs>
      </Box>
      {items.map((item, index) => (
        <Box role="tabpanel" hidden={index !== index} key={index}>
          {tabIndex === index && <Box sx={{ p: 1 }}>{item.children}</Box>}
        </Box>
      ))}
    </Box>
  );
};
